import { useMutation } from '@tanstack/react-query';

import { paymentTypeTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removePaymentType: paymentTypeTypes.RemovePaymentTypeData = ({ _id }) => {
  return axios.delete(`/payment-types/${_id}`);
};

type QueryFnType = typeof removePaymentType;

type UseRemovePaymentTypeOptions = {
  config?: MutationConfig<(params: Parameters<QueryFnType>[0]) => ReturnType<QueryFnType>>;
};

export function useRemovePaymentType({ config = {} }: UseRemovePaymentTypeOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-types']);
    },
    ...config,
    mutationFn: removePaymentType,
  });
}
